export default __webpack_public_path__ + "static/media/mobility_mobile.613e1986.jpg";